import { render, staticRenderFns } from "./CoozzyArrowsAltHIcon.vue?vue&type=template&id=5a1906ae&scoped=true"
import script from "./CoozzyArrowsAltHIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyArrowsAltHIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyArrowsAltHIcon.vue?vue&type=style&index=0&id=5a1906ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1906ae",
  null
  
)

export default component.exports